import React from 'react';

export const Spinner = () => {
  return (
    <div className="spinner-border text-secondary" role="status">
      <span className="sr-only"></span>
    </div>
  );
};
